import { TAreas } from 'src/constants/lead/leadTypes';
import { TChannelConversation, TChannelConversationRecord } from './types';

/**
 * Maps a `WarboxConversation` to what the channel resolution reads.
 */
export const toChannelConversation = (
    record: TChannelConversationRecord | null
): TChannelConversation | null =>
    record
        ? {
              channel: record.channel,
              area: record.area?.name as TAreas,
              messagingWindowExpiresAt: record.messagingWindowExpiresAt,
              lastInboundMessageAt: record.lastInboundMessageAt,
          }
        : null;
